module.exports = __webpack_public_path__ + "media/media/about/gti-b5b368f7ba38738ee54122b621aa994b.png";